module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/controls/command-bar/command/command.component.scss
// module id = ./src/app/controls/command-bar/command/command.component.scss
// module chunks = main